import React, { memo, forwardRef, ForwardedRef } from "react";
import { FlexColumn } from "src/components/ui/common";
import { colors } from "src/theme";
import { Caption, Headline } from "src/theme/typography";
// styles
import { InputWrapper, Textarea } from "./reviewInput.styles";

type IReviewContainerDefaultProps = JSX.IntrinsicElements["textarea"];

interface IReviewContainerProps extends IReviewContainerDefaultProps {
  error?: string;
}

const ReviewContainer = (
  { error, ...rest }: IReviewContainerProps,
  ref: ForwardedRef<HTMLTextAreaElement>,
) => {
  return (
    <FlexColumn gap="8px">
      <Headline>Your review</Headline>
      <Caption>Describe your experience</Caption>
      <InputWrapper filled={!error}>
        <Textarea rows={5} {...rest} ref={ref} />
      </InputWrapper>
      {error && <Caption textColor={colors.redDark}>{error}</Caption>}
    </FlexColumn>
  );
};

export default memo(forwardRef(ReviewContainer));
